import {
    useEffect,
    useState,
    useCallback,
} from 'react'

import {
    useLocation,
} from 'react-router-dom'

const booleanMap = {
    true: true,
    false: false,
}

// use to keep filters in table moving from another rout
const useRouteStateFilter = () => {
    const {
        state,
    } = useLocation()

    const [
        filterState,
        setFilterState,
    ] = useState(() => {
        return state?.filter && Object.entries(state?.filter).reduce((acc, [
            key,
            value,
        ]) => {
            return {
                ...acc,
                [key]: value === 'false' || value === 'true' ? booleanMap[value] : value,
            }
        }, {})
    })

    const clearFilterState = useCallback(() => {
        return setFilterState(undefined)
    }, [])

    useEffect(() => {
        return clearFilterState
    }, [clearFilterState])

    return {
        filter: filterState, clearFilterState,
    }
}

export default useRouteStateFilter
